import React, { useEffect, useRef, useState } from 'react'
import { dateToString } from '../../../utils/dateUtils'

const ChartTooltip = ({
    active,
    payload,
    label,
    coordinate,
    roundValues = true,
}) => {
    if (active && coordinate) {
        const formattedLabel = dateToString(label, 'MM/DD/YYYY HH:mm:ss')

        // Fallback: use window width if viewBox isn't available
        const tooltipWidth = 200
        const windowWidth =
            typeof window !== 'undefined' ? window.innerWidth : 1200
        const shouldFlip = coordinate.x + tooltipWidth > windowWidth

        return (
            <div
                className="customTooltip"
                style={{
                    transform: shouldFlip ? 'translateX(-108%)' : 'none',
                }}
            >
                <p className="customTooltipLabel">{formattedLabel}</p>
                <ul className="customTooltipList">
                    {payload &&
                        payload.map((x, idx) =>
                            x.name !== 'NoTooltipItem' ? (
                                <li style={{ color: x.color }} key={idx}>
                                    <span className="customTooltipItemName">
                                        {`${x.name} ${x.unit}`}
                                    </span>
                                    <span> : </span>
                                    <span className="customTooltipItemValue">
                                        {x.payload &&
                                            x.payload[`${x.name}-All`] &&
                                            Array.isArray(
                                                x.payload[`${x.name}-All`]
                                            ) &&
                                            x.payload[`${x.name}-All`]
                                                .map((p) =>
                                                    roundValues
                                                        ? Math.round(p * 100) /
                                                          100
                                                        : p
                                                )
                                                .join(', ')}
                                    </span>
                                </li>
                            ) : null
                        )}
                </ul>
            </div>
        )
    }
    return null
}

export default ChartTooltip
